import { toast } from "sonner";

import { t } from "@/hooks/shared/use-settings";

export const requireSprintSelection = (sprintId: string | null | undefined): sprintId is string => {
    if (sprintId) return true;
    toast.error(t("Please select a sprint from the top bar first."));
    return false;
};

export const requireProjectSelection = (projectId: string | null | undefined): projectId is string => {
    if (projectId) return true;
    toast.error(t("Please select a project from the top bar first."));
    return false;
};
